import * as React from 'react';
import PropTypes from 'prop-types';
import DropDownIcon from '@sfly/uig-svg-icon/action/dropdown';

// This component will render list of items passed to it (supported only for list of strings and numbers).
export class DropDownComponent extends React.Component {

    constructor(props, state) {
        super(props, state);
        this.state = this.getInitialState();
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        // this.select = this.select.bind(this);
    }

    getInitialState() {
        return {
            listVisible: false
        };
    }

    // select(event) {
    //     let selectedIndex = Number((item.currentTarget).dataset.id);
    //     this.setState({ selected: this.props.list[selectedIndex]});
    // }

    show() {
        this.setState({
            listVisible: true
        });
        document.addEventListener('click', this.hide);
    }

    hide() {
        this.setState({ listVisible: false });
        document.removeEventListener('click', this.hide);
    }

    renderLabel(dropDownLabel, selected = false) {
        return (
            <div className={`drop-down-label${selected ? ' selected' : ''}`}>
                <span className={'item-left'}>{dropDownLabel}</span>
            </div>
        );
    }

    renderListItems(dropDownItems) {
        if(!dropDownItems || dropDownItems.length < 1) return null;

        var items = [];

        dropDownItems.map((item, index) => {
            items.push(
                <div className={'drop-down-list-item'} onClick={this.props.onClick} key={`option-${index}`} data-id={index}>
                    {this.renderLabel(item, this.props.selected === index)}
                </div>
            );
        });

        return items;
    }

    render() {
        return (
            <div id={this.props.id} className={`drop-down ${this.props.className}`} data-value={this.props.value}>
                <div className={`dropdown-container${this.state.listVisible ? ' show' : ''}`}>
                    <div className={
                        `dropdown-display${this.state.listVisible ? ' clicked' : ''}`
                    } onClick={this.show}>
                        <DropDownIcon />
                        {this.renderLabel(this.props.dropDownItems[this.props.selected], true)}
                    </div>
                    <div className="dropdown-list">
                        <div className="dropdown-list-items">{this.renderListItems(this.props.dropDownItems)}</div>
                    </div>
                </div>
            </div>
        );
    }
}

DropDownComponent.propTypes = {
    id: PropTypes.string.isRequired,
    dropDownItems: PropTypes.array.isRequired,
    selected: PropTypes.any,
    onClick: PropTypes.func,
    className: PropTypes.string,
    value: PropTypes.any
};

DropDownComponent.defaultProps = {
    selected: '',
    onClick: () => {},
    className: '',
    value: ''
};

